<template>
  <PageContent :title="$t('bankAccountListingAdd.title')">
    <div class="box is-8">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <transition name="fade" mode="out-in" appear>
          <form @submit.prevent="handleSubmit(onFormSubmit)" class="form">
            <fieldset>
              <div :style="{ marginBottom: '30px' }">
                <h4>{{ finInstBankName }}</h4>
              </div>
              <div class="form-grid">
                <div class="column is-8">
                  <valid-input
                    name="Description"
                    label="Description"
                    maxlength="100"
                    type="textarea"
                    vid="description"
                    placeholder="Description"
                    rules="required|max:100"
                    v-model="formData.description"
                  />
                </div>
                <div class="column is-8">
                  <valid-input
                    name="Balance"
                    label="Balance"
                    type="text"
                    vid="amount"
                    placeholder="Balance"
                    rules="required"
                    v-model="formData.amount"
                  />
                </div>
                <div class="column is-8">
                  <valid-input
                    name="Check Number"
                    label="Check Number"
                    maxlength="50"
                    type="number"
                    vid="checkNumber"
                    placeholder="Check Number"
                    rules="required|max:50"
                    v-model="formData.checkNumber"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                <div class="field">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </fieldset>
            <button type="submit" class="button is-primary is-rounded" :disabled="loading">
              Add
            </button>
          </form>
        </transition>
      </ValidationObserver>
    </div>
  </PageContent>
</template>

<script>
//
import { mapState } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
//
// components
import { ValidationError } from '@/services/errors'
import kms from '@/services/kms'
import PageContent from '@/containers/PageContent'
import ValidInput from '@/components/inputs/ValidInput'

import moment from 'moment'
const today = moment()

import { notifyMessage, notifyError } from '@/services/notify'

let DEFAULT_FORM_VALUES = {
  description: '',
  amount: 0,
  checkNumber: ''
}

export default {
  components: {
    PageContent,
    ValidInput,
    ValidationObserver,
    ValidationProvider
  },

  data: function() {
    return {
      formComplete: false,
      formData: {
        ...DEFAULT_FORM_VALUES
      },
      loading: true,
      finInstBankName: '',
      bankAccountID: 0,
      formatDateFn: function(value) {
        return value != null
          ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss.967Z')
          : ''
      }
    }
  },

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  mounted() {
    this.resetForm()
  },

  watch: {
    hoaId() {
      this.reload()
    }
  },

  methods: {
    async reload() {},

    async resetForm() {
      this.loading = true
      this.formData = { ...DEFAULT_FORM_VALUES }
      if (this.$refs.form) {
        this.$refs.form.reset()
      }

      this.finInstBankName = this.$route.params.finInstBankName
      this.bankAccountID = this.$route.params.id

      console.debug(`params= ${this.bankAccountID} - ${this.finInstBankName}`)

      this.loading = false
    },

    getFormPayload() {
      const payload = {
        bankAccountListingID: 0,
        bankAccountID: this.bankAccountID,
        hoaID: this.hoaId,
        description: this.formData.description,
        amount: parseFloat(this.formData.amount),
        checkNumber: this.formData.checkNumber,
        transactionDate: this.formatDateFn(today.toDate())
      }
      return payload
    },

    async onFormSubmit() {
      try {
        this.loading = true
        const returnPayload = this.getFormPayload()
        console.debug(returnPayload)

        const path = `/CheckbookReconciliation/BankAccountListing`
        const results = await kms.post(path, returnPayload)

        console.debug(JSON.stringify(results))

        if (results.bankAccountListingID > 0) {
          this.formComplete = true
          this.$router.push({
            name: 'bankAccount',
            params: { id: this.bankAccountID }
          })
          notifyMessage(`${this.finInstBankName} was successfully added.`)
        } else {
          notifyError('There was a problem creating your transaction.')
        }
      } catch (e) {
        // If this is a validation error, get the details for each field
        if (e instanceof ValidationError) {
          this.$refs.form.setErrors(e.fields)
        }

        notifyError(e)
      }
      this.loading = false
    }
  },
  i18n: {
    messages: {
      en: { bankAccountListingAdd: { title: 'Add Transaction' } }
    }
  }
}
</script>
